import { DesignTokens } from "../../types"
import { sizes } from "./sizes"

export const spaces: DesignTokens.Spaces = {
  spacing2: sizes[2],
  spacing4: sizes[4],
  spacing8: sizes[8],
  spacing12: sizes[12],
  spacing16: sizes[16],
  spacing20: sizes[20],
  spacing24: sizes[24],
  spacing32: sizes[32],
  spacing40: sizes[40],
  spacing48: sizes[48],
  spacing64: sizes[64],
}
